import service from '@/api/service/service';
import qs from "qs";


/* 是否需要进行问卷调查 */
export function questionCheck(params = {}) {
  return service({
    url: "/api/survey/survey_question_check.json",
    method: 'GET',
    params
  });
}

/* 请求问卷调查问题 */
export function getQuestion(params = {}) {
    return service({
      url: "/api/survey/survey_question_list.json",
      method: 'GET',
      params
    });
}

/* 问卷调查提交 */
export function postQuestion(data ={}) {
  return service({
    url: '/api/survey/survey_question_save.json',
    method: 'POST',
    data: qs.stringify(data)
  })
}

